// Testimonials / Why Choose section content
export const testimonials = {
  headline: 'Why Choose SlideFactory?',

  items: [
    {
      quote: 'Multi-AI flexibility means you\'re never locked into one provider. Switch between OpenAI, Azure, Anthropic, or run locally with Ollama - all through the same interface. Your choice, your control.',
      author: 'AI Provider Freedom'
    },
    {
      quote: 'Enterprise-grade security from day one. JWT tokens, OAuth, encrypted storage, and deployment options that keep your data where you need it. Built for compliance-heavy organizations.',
      author: 'Enterprise Security'
    },
    {
      quote: 'N8N integration connects SlideFactory to over 400+ apps. Trigger presentations from Salesforce, HubSpot, Notion, or any tool in your stack. Automate everything.',
      author: 'Workflow Integration'
    }
  ]
}
